/**
 * Mixin global para listagens paginadas.
 * Garante :key estável (página + primeiro item) para evitar tabela "uma página atrás"
 * quando o DOM é alterado (ex.: tradução do navegador).
 *
 * Em toda listagem com el-table + el-pagination use:
 *   :key="listagemTableKey('prefixo', arrayDados, paginaAtual)"
 * onde paginaAtual é o número da página (1-based).
 */
export default {
    methods: {
        listagemTableKey(prefix, dataArray, page) {
            const pageNum = page != null ? Number(page) : 1;
            const first = dataArray && dataArray.length > 0 ? dataArray[0] : null;
            const id = first != null ? (first.id ?? first.idLinha ?? '') : '';
            return `${prefix}-${pageNum}-${id}`;
        }
    }
};
